import extensionsConstants from "../utils/ExtensionsConstants.js";
const actionTypes = {
  SET_USER_CONTEXT: extensionsConstants.SET_USER_CONTEXT,
  SET_PARTIAL_USER_CONTEXT: extensionsConstants.SET_PARTIAL_USER_CONTEXT
};
export {
  actionTypes
};
//# sourceMappingURL=Extensions.ducks.types.js.map
